import { Skeleton } from 'components/app-components/ui/skeleton';
import MemoizedCopyableText from 'components/generic-components/copyableText';

interface CardNumberProps {
  cardNumberSeparated?: string[];
  showDetails: boolean;
  isLoadingCardDetails: boolean;
}

/**
 * Card number field with copy functionality
 */
export const CardNumber = ({ cardNumberSeparated, showDetails, isLoadingCardDetails }: CardNumberProps) => {
  return (
    <div className="flex items-center gap-2">
      {isLoadingCardDetails ? (
        <Skeleton className="h-4 w-40 bg-neutral-500" />
      ) : (
        <p className="text-base font-medium tabular-nums text-white">
          {showDetails
            ? `${cardNumberSeparated?.join(' ') || '----'}`
            : `•••• •••• •••• ${cardNumberSeparated?.[3] || '----'}`}
        </p>
      )}
      {showDetails && !isLoadingCardDetails && cardNumberSeparated && (
        <span className="text-white">
          <MemoizedCopyableText
            text={cardNumberSeparated.join(' ')}
            onlyIconMode={true}
            showBorder={false}
            iconStrokeColor="white"
          />
        </span>
      )}
    </div>
  );
};
